import React from "react" 
import { useDetailScreenCtx } from "../DetailScreensRender"
import { TrxDetailLabel, TrxDetailValue } from "."

export default function TrxDataElement({ id, label, value, dir="row", size="md" }:{ id?:string; label:string; value:any; dir?:string; size?:string }){
  return (
    <div 
      id={id} 
      style={{
        display: "flex",
        flexDirection: dir === "col" ? "column" : "row",
        justifyContent: "space-between",
        alignItems: "flex-start",
        paddingTop: "0.15rem",
        paddingBottom: "0.15rem",
      }}
    >
      { label.length > 0 && <TrxDetailLabel label={label} value={value} size={size} /> }
      <TrxDetailValue value={value} size={size} />
    </div>
  )
}